import { BlobServiceClient, BlockBlobClient } from '@azure/storage-blob';
import { AxiosResponse } from 'axios';

import { showToast, ToastType } from '@/helpers/toast';
import i18n from '@/i18n';

export const getBlobClient = (data: AxiosResponse) => {
  if (!data) {
    return;
  }

  const getToken = (token: string) => {
    return token.startsWith('?') ? token : `?${token}`;
  };

  return new BlobServiceClient(data.data.baseUrl + getToken(data.data.token))
    .getContainerClient('')
    .getBlockBlobClient(data.data.path);
};

export const getPictureUrl = (data: AxiosResponse) => {
  return `${data.data.baseUrl}/${data.data.path}`;
};

export const uploadPicture = async (
  blobClient: BlockBlobClient | undefined,
  uploadedPicture: File
) => {
  if (!blobClient) {
    return false;
  }

  const didUploadSucceed = await tryUploadPicture(
    uploadedPicture,
    blobClient,
    i18n.t('assetError', { ns: 'common' })
  );
  if (!didUploadSucceed) {
    return false;
  }

  return true;
};

export const tryUploadPicture = async (
  picture: File,
  blobClient: BlockBlobClient,
  errorMessage: string
) => {
  try {
    await blobClient.uploadBrowserData(picture);
    return true;
  } catch {
    showToast(ToastType.INFO, i18n.t('retry', { ns: 'common' }));
  }

  showToast(ToastType.ERROR, i18n.t('uploadError', { ns: 'common', error: errorMessage }));

  return false;
};
